import logo from '/src/img/logoRecon.png';

const WA_MESSAGE = encodeURIComponent('Olá, fiz uma simulação no site e quero saber mais sobre a restituição do meu consórcio.');
const WA_LINK = `https://wa.me/5511998881316?text=${WA_MESSAGE}`;

export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <img
              src={logo}
              alt="Restituição Consórcio"
              width="150px"
              // className="h-14 md:h-16 w-auto object-contain"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs mb-5">
              Especialistas em restituição e revisão de consórcios. Recuperamos o que é seu por direito, com segurança jurídica e transparência.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-facebook-circle-line', href: '#' },
                { icon: 'ri-whatsapp-line', href: WA_LINK },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center border border-gray-700 hover:border-green-500 hover:text-green-400 rounded-full text-gray-400 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Serviços</h4>
            <ul className="space-y-2.5">
              {['Restituição de Consórcio', 'Revisão de Contrato', 'Análise Gratuita', 'Ação Judicial', 'Consultoria Jurídica'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollTo('simulador')}
                    className="text-gray-400 hover:text-green-400 text-sm transition-colors cursor-pointer whitespace-nowrap text-left"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <i className="ri-whatsapp-line text-green-400 mt-0.5 flex-shrink-0"></i>
                <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors cursor-pointer">
                  Fale pelo WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <i className="ri-map-pin-line text-green-400 mt-0.5 flex-shrink-0"></i>
                <span>Atendimento em todo o Brasil</span>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <i className="ri-time-line text-green-400 mt-0.5 flex-shrink-0"></i>
                <span>Seg–Sex: 8h às 18h<br />Sáb: 9h às 13h</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} Restituição Consórcio. Todos os direitos reservados.
          </p>
          <div className="flex gap-4 text-xs text-gray-500">
            <a href="#" className="hover:text-green-400 transition-colors cursor-pointer whitespace-nowrap">Política de Privacidade</a>
            <span className="text-green-700">|</span>
            <a href="#" className="hover:text-green-400 transition-colors cursor-pointer whitespace-nowrap">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
